import {
    AppScopesVersionModel,
    AppVersionApprovalStatus,
    AppVersionApprovalStatusReason,
    AuthScopeDisplayModel,
    WebhookEventDisplayModel,
} from '../../api/app.api';

const statusLabels: Record<AppVersionApprovalStatus, string> = {
    [AppVersionApprovalStatus.NotStarted]: 'Review in progress',
    [AppVersionApprovalStatus.Rejected]: 'Rejected',
    [AppVersionApprovalStatus.Approved]: 'Approved',
};

const reasonLabels: Record<AppVersionApprovalStatusReason, string | null> = {
    [AppVersionApprovalStatusReason.WithinApprovedUseCases]:
        'API scopes are contained within approved use cases',
    [AppVersionApprovalStatusReason.NotWithinApprovedUseCases]:
        'API scopes are not contained within approved use cases',
    [AppVersionApprovalStatusReason.NewerVersionSubmitted]: 'Newer version submitted for approval',
    [AppVersionApprovalStatusReason.Other]: null,
};

/** A scopes version with its display labels and approval-derived values resolved. */
export interface AppScopesVersionViewModel {
    version: number;
    createdOn: Date;
    createdBy: string;
    authScopes: AuthScopeDisplayModel[];
    webhookEvents: WebhookEventDisplayModel[];
    approvalStatus: AppVersionApprovalStatus;
    statusLabel: string;
    /** The descriptive reason label, or null when the version has no approval reason. */
    reasonLabel: string | null;
    /** The reviewer and review date once the version has been approved or rejected, otherwise null. */
    review: { reviewedBy: string; reviewedOn: Date } | null;
}

export function createAppScopesVersionViewModel(
    model: AppScopesVersionModel,
): AppScopesVersionViewModel {
    return {
        version: model.version,
        createdOn: model.dateTime,
        createdBy: model.userName,
        authScopes: model.authScopes,
        webhookEvents: model.webhookEvents,
        approvalStatus: model.approvalStatus,
        statusLabel: statusLabels[model.approvalStatus],
        reasonLabel:
            model.approvalStatusReason !== null ? reasonLabels[model.approvalStatusReason] : null,
        review:
            model.reviewedBy !== null && model.reviewedOn !== null
                ? { reviewedBy: model.reviewedBy, reviewedOn: model.reviewedOn }
                : null,
    };
}
